module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_16-3d183ec860fa6457c984780d4fed908c.jpg";